import getStorageLanguage from './_getStorageLanguage'
import getNavigatorLanguage from './_getNavigatorLanguage'

export default () => {
  return (!getStorageLanguage()) ? getNavigatorLanguage() : getStorageLanguage()
}
